import API from "@/axios";
import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import {
  AutoApprovePayload,
  AutomationState,
  UpdateThresholdValuePayload,
  UpdateRetentionDaysPayload,
  ToggleThresholdPayload,
  ToggleThresholdReviewPayload,
} from "../types";

const actions: ActionTree<AutomationState, RootState> = {
  initializeThreshold({ dispatch }) {
    return API.get("/settings/profile").then(async (res) => {
      if (res.data) {
        const {
          autoApproveEnabled,
          autoApproveThreshold,
          autoApproveThresholdFacial,
          autoApproveEnabledReview,
          dataRetentionDays,
        } = res.data.data;
        dispatch("setEnabled", autoApproveEnabled);
        dispatch("setEnabledReview", autoApproveEnabledReview);
        dispatch("setThreshold", autoApproveThreshold || 0);
        dispatch("setThresholdFacial", autoApproveThresholdFacial || 0);
        dispatch("setRetentionDays", dataRetentionDays || 0);
      }
    });
  },
  toggleThresholdReview({ dispatch }, payload: ToggleThresholdReviewPayload) {
    const { enabledReview } = payload;
    dispatch("setEnabledReview", enabledReview);
  },
  toggleThreshold({ dispatch }, payload: ToggleThresholdPayload) {
    const { enabled } = payload;
    dispatch("setEnabled", enabled);
  },
  updateThresholdValue({ dispatch }, payload: UpdateThresholdValuePayload) {
    const { threshold } = payload;
    dispatch("setThreshold", threshold);
  },
  updateThresholdFacialValue(
    { dispatch },
    payload: UpdateThresholdValuePayload
  ) {
    const { thresholdFacial } = payload;
    dispatch("setThresholdFacial", thresholdFacial);
  },
  updateRetentionDaysValue({ dispatch }, payload: UpdateRetentionDaysPayload) {
    const { retentionDays } = payload;
    dispatch("setRetentionDays", retentionDays);
  },
  setEnabled({ commit }, enabled) {
    commit("setEnabled", enabled);
  },
  setEnabledReview({ commit }, enabled) {
    commit("setEnabledReview", enabled);
  },
  setThreshold({ commit }, threshold) {
    commit("setThreshold", threshold);
  },
  setThresholdFacial({ commit }, thresholdFacial) {
    commit("setThresholdFacial", thresholdFacial);
  },
  setRetentionDays({ commit }, retentionDays) {
    commit("setRetentionDays", retentionDays);
  },
  async configureAutoApprove(context, payload: AutoApprovePayload) {
    const {
      enabled,
      threshold,
      thresholdFacial,
      enabledReview,
      retentionDays,
    } = payload;
    return API.post("/settings/autoapprove", {
      enabled: enabled,
      threshold: threshold,
      thresholdFacial: thresholdFacial,
      enabledReview: enabledReview,
      retentionDays: retentionDays,
    }).then(async (res) => {
      return res.data;
    });
  },
};

export default actions;
